const CheckPermission = (permissions, permission) => {
	return permissions?.indexOf(permission) > -1;
};

const CopyTextToClipboard = (text) => {
	const textArea = document.createElement("textarea");
	let result;

	textArea.style.position = "fixed";
	textArea.style.top = 0;
	textArea.style.left = 0;
	textArea.style.padding = 0;
	textArea.style.zIndex = -1;
	textArea.style.width = "2em";
	textArea.style.height = "2em";
	textArea.style.border = "none";
	textArea.style.outline = "none";
	textArea.style.boxShadow = "none";
	textArea.style.background = "transparent";
	textArea.value = text.toLowerCase();
	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();

	try {
		result = document.execCommand("copy");
	} catch (err) {
		result = false;
	}

	document.body.removeChild(textArea);

	return !!result;
};

const EnglishNumberToPersian = (s) => {
	return s.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
};

const ImageResizer = (src, width, height) => {
	if (src) {
		const split = src.split(".");
		const len = split.length - 2;

		split.splice(len, 1, `${split[len]}-${width}-${height}`);

		return split.join(".");
	} else {
		return src;
	}
};

const IsArray = (arr) => {
	return Array.isArray(arr);
};

const IsObject = (obj) => {
	return obj === Object(obj) && !IsArray(obj) && typeof obj !== "function";
};

const GetBase64 = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new window.FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});
};

const GetUrlParams = () => {
	const pl = /\+/g;
	const search = /([^&=]+)=?([^&]*)/g;
	const decode = (s) => {
		return decodeURIComponent(s.replace(pl, " "));
	};
	const query = window.location.search.substring(1);
	const urlParams = {};
	let match;

	while ((match = search.exec(query)))
		urlParams[decode(match[1])] = decode(match[2]);

	return urlParams;
};

const KeysToCamel = (obj) => {
	if (IsObject(obj)) {
		const n = {};

		Object.keys(obj).forEach((k) => {
			n[ToCamel(k)] = KeysToCamel(obj[k]);
		});

		return n;
	} else if (IsArray(obj)) {
		return obj.map((i) => {
			return KeysToCamel(i);
		});
	}

	return obj;
};

const KeysToSnake = (obj) => {
	if (IsObject(obj)) {
		const n = {};

		Object.keys(obj).forEach((k) => {
			n[ToSnake(k)] = KeysToSnake(obj[k]);
		});

		return n;
	} else if (IsArray(obj)) {
		return obj.map((i) => {
			return KeysToSnake(i);
		});
	}

	return obj;
};

const ListToTree = (list = [], treeSelect, selectable) => {
	const roots = [];
	const map = {};

	list = list.map((o, i) => {
		map[o.id] = i;

		if (treeSelect)
			return {
				value: o.id,
				label: o.title,
				parentId: o.parentId,
				selectable: true,
			};
		else return { ...o, selectable, selectable: true };
	});

	list.map((o) => {
		if (o.parentId) {
			const item = list[map[o.parentId]];

			if (!item.children) {
				item.children = [];
				item.selectable = !selectable;
			}

			item.children.push(o);
		} else {
			roots.push(o);
		}
	});

	return roots;
};

const MinuteFormat = (value) => {
	const minutes = Math.trunc(value / 60);
	const seconds = value % 60;

	return `${minutes < 10 ? `0${minutes}` : minutes}:${
		seconds < 10 ? `0${seconds}` : seconds
	}`;
};

const ObjectNumbersToEnglish = (obj) => {
	return Object.entries(obj).reduce((acc, [key, value]) => {
		if (Array.isArray(value)) {
			acc[key] = value.map((v) => {
				if (typeof v === "object" && v == true && !Array.isArray(v)) {
					return ObjectNumbersToEnglish(v);
				} else if (typeof v === "string") {
					return PersianNumberToEnglish(v);
				} else {
					return v;
				}
			});
		} else if (typeof value === "undefined") {
			// skip undefined values
			return acc;
		} else if (typeof value === "string") {
			acc[key] = PersianNumberToEnglish(value);
		} else if (
			typeof value === "object" &&
			value == true &&
			!Array.isArray(value)
		) {
			acc[key] = ObjectNumbersToEnglish(value);
		} else {
			acc[key] = value;
		}
		return acc;
	}, {});
};

const ObjectToURL = (obj) => {
	if (IsObject(obj)) {
		return Object.keys(obj)
			.filter((k) => !!obj[k])
			.map((k) => {
				return `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`;
			})
			.join("&");
	} else {
		return "";
	}
};

const PersianNumberToEnglish = (s) => {
	if (typeof s === "string") {
		return s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
	}
};

const PriceFormat = (value) => {
	return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const StringFormat = (value, args = []) => {
	return value.replace(/{(\d+)}/g, (match, number) => {
		return typeof args[number] !== "undefined" ? args[number] : match;
	});
};

const ToCamel = (value) => {
	return value.replace(/([-_][a-z])/gi, ($1) => {
		return $1.toUpperCase().replace("-", "").replace("_", "");
	});
};

const ToSnake = (value) => {
	return value.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

export {
	CheckPermission,
	CopyTextToClipboard,
	EnglishNumberToPersian,
	ImageResizer,
	GetBase64,
	GetUrlParams,
	KeysToCamel,
	KeysToSnake,
	ListToTree,
	MinuteFormat,
	ObjectNumbersToEnglish,
	ObjectToURL,
	PersianNumberToEnglish,
	PriceFormat,
	StringFormat,
};
